module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_10-aec7aeb7af1aaf374fe312cb7480c423.jpg";